<template>

<div v-if='isReady' class='text-center'>

    <div v-if='!finished'>
        <img src="/resources/images/spinner.svg" alt="spinner" class="spinner">
        <h4 class="mb-0"> {{ title }} </h4>

        <div class="time-count mt-0">
            <span>{{ daysLeft }}</span> дни 
            <span>{{ hoursLeft }}</span> часа 
            <span>{{ minutesLeft }}</span> минути
        </div>
    </div>
    
    <div v-if='finished'>
        <h5 class="mb-0">
            {{ message }}
        </h5>
    </div>
</div>


</template>

<script>
    export default {

        mounted() {

        },

        created() {
            this.init();

            if( typeof this.msg == 'string' && this.msg ) {
                this.message = this.msg;
            }

            if( typeof this.t == 'string' && this.t ) {
                this.title = this.t;
            }
        },

        props : ['end','msg', 't'],

        data() {
            return {

                isReady     : false,
                title       : 'Оставащо време:',
                daysLeft    : 0,
                hoursLeft   : 0,
                minutesLeft : 0,
                finished    : false, 
                message     : 'Зададеното време за етапа е изтелкло. Скоро ще получите достъп до всички налични оферти.'

            }
        },

        methods : {

            init() {

                if( !this.end ) {
                    return;
                }

                var now = new Date();
                var endDate = new Date( this.end.split('-').join('/') );

                //Seconds left                
                var diff = Math.ceil( ( endDate.getTime() - now.getTime() ) / 1000 );

                if( diff <= 0 ) {
                
                    this.finished = true;
                
                } else {

                    this.daysLeft = Math.floor(diff / 86400);

                    diff -= this.daysLeft * 86400;

                    this.hoursLeft = Math.floor(diff / 3600) % 24;
                    diff -= this.hoursLeft * 3600;

                    this.minutesLeft = Math.floor(diff / 60) % 60;
                    diff -= this.minutesLeft * 60;
                }

                this.isReady = true;
            }

        },

        watch : {
            end( n,o ) {
               this.init();
            } 
        }

    }
</script>
